// use configureStore of @reduxjs/toolkit instead of
// createStore of redux
// reference:
// https://www.codecademy.com/courses/learn-redux/lessons/the-redux-toolkit/exercises/converting-the-store-to-use-configurestore
// https://redux-toolkit.js.org/introduction/getting-started
import { configureStore } from '@reduxjs/toolkit';

import { calendarApi } from '../../features/calendar';

const createStore = () =>
  configureStore({
    reducer: {
      [calendarApi.reducerPath]: calendarApi.reducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(calendarApi.middleware)
  });

export default createStore;
